import orderFilter from './orderFilter'
import palette from 'theme/palette'

const PENDING_STATUS = 'pending'
const ONGOING_STATUS = 'ongoing'
const OVERDUE_STATUS = 'overdue'
const FINALIZED_STATUS = 'finalized'

const KANBAN_COLUMN_ROLE_CUSTOM = 'custom'
const KANBAN_COLUMN_ROLE_PENDING = 'pending'
const KANBAN_COLUMN_ROLE_IN_PROGRESS = 'in_progress'
const KANBAN_COLUMN_ROLE_IN_APPROVAL = 'in_approval'
const KANBAN_COLUMN_ROLE_FINALIZED = 'finalized'

const TASK_NAME_MAX_LENGTH = 120

const VIEW_MODE_LIST = 'list'
const VIEW_MODE_KANBAN = 'kanban'

const SOURCEABLE_TYPE_COMPLAINT = 'Complaint'

const DRAG_TYPE_COLUMN = 'COLUMN'
const DRAG_TYPE_CARD = 'CARD'

const KANBAN_DEFAULT_ORDER = 'order_position DESC'
const KANBAN_COLUMN_STATES_ORDER = 'order_position DESC NULLS LAST'
const KANBAN_ORDER_FIELD = 'order_position'

const LINK_STATUS_ACTIVE_VALUE = ''
const LINK_STATUS_UNLINKED_VALUE = 'unlinked'
const LINK_STATUS_SOURCE_REMOVED_VALUE = 'source_removed'

const ALL_ACTIVITIES_VALUE = 'all'
const ACTIVITIES_PENDING_VALUE = PENDING_STATUS
const ACTIVITIES_IN_PROGRESS_VALUE = ONGOING_STATUS
const ACTIVITIES_DELAYED_VALUE = OVERDUE_STATUS
const ACTIVITIES_CONCLUDED_VALUE = FINALIZED_STATUS

const ACTIVITIES_TAB = [
  { value: ALL_ACTIVITIES_VALUE, label: 'Todas' },
  { value: ACTIVITIES_PENDING_VALUE, label: 'Pendentes' },
  { value: ACTIVITIES_IN_PROGRESS_VALUE, label: 'Em Andamento' },
  { value: ACTIVITIES_DELAYED_VALUE, label: 'Atrasadas' },
  { value: ACTIVITIES_CONCLUDED_VALUE, label: 'Finalizadas' },
]

const HIGH = 'high'
const MEDIUM = 'medium'
const LOW = 'low'
const SEVERE = 'severe'

const PRIORITY_ITEMS = [
  { id: SEVERE, name: 'Severa' },
  { id: HIGH, name: 'Alta' },
  { id: MEDIUM, name: 'Média' },
  { id: LOW, name: 'Baixa' },
]

const PRIORITY_LABELS = {
  [SEVERE]: 'Severa',
  [HIGH]: 'Alta',
  [MEDIUM]: 'Média',
  [LOW]: 'Baixa',
}

const CUSTOM_ORDER_FIELDS = [
  {
    value: orderFilter.CUSTOM_FIELD_DESC,
    name: 'Posição',
    orderValue: KANBAN_ORDER_FIELD,
  },
]

const TASK_ATTACHMENT_FILE_TYPES = '.jpg,.jpeg,.png,.pdf,.doc,.docx,.xls,.xlsx'

const KANBAN_COLUMN_PALETTE_COLORS = [
  '#FFFFFF',
  '#92D050',
  '#FFFF00',
  '#FFC000',
  '#FF0000',
  '#000000',
  '#2196F3',
  '#03A9F4',
  '#00BCD4',
  '#009688',
  '#4CAF50',
  '#8BC34A',
  '#CDDC39',
  '#FFEB3B',
  '#FFC107',
  '#FF9800',
  '#FF5722',
  '#F44336',
  '#E91E63',
  '#9C27B0',
  '#673AB7',
  '#3F51B5',
  '#795548',
  '#607D8B',
]

const SOURCE_ORIGIN_LABELS = {
  ChangesManagement: 'Gestão de Mudanças',
  Complaint: 'Canal de Denúncias',
  ConsentForm: 'Consentimentos',
  CookieBanner: 'Banner de Cookies',
  DataProcess: 'Processos',
  DataProcessTreatment: 'Processos - Tratamento',
  GovernanceProject: 'Projetos de Governança',
  Incident: 'Incidentes',
  MonitoringManagementKpi: 'Monitoramento - KPI',
  MonitoringManagementPmc: 'Monitoramento - Melhoria Contínua',
  PrivacyByDesign: 'Privacy by Design',
  PrivacyPolicy: 'Documentos',
  Questionnaire: 'Diagnósticos - Questionários',
  QuestionControl: 'Diagnósticos - Medidas de Segurança',
  SolicitationTicket: 'Chamados',
  Ticket: 'Solicitações de titulares',
}

// tag de permissão LIST usada pra decidir se o módulo aparece na aba
// "Atividades Automáticas" das Configurações de Notificação. GovernanceProject
// não entra aqui pq depende de hasProjectAssignments (ver NotificationSettings.js)
const SOURCE_ORIGIN_PERMISSION_TAGS = {
  ChangesManagement: 'list_changes_management',
  Complaint: 'list_complaints',
  ConsentForm: 'list_consent_form',
  CookieBanner: 'authenticate_cookie',
  DataProcess: 'list_data_processes',
  DataProcessTreatment: 'list_data_process_treatments',
  GovernanceProject: 'create_governance_project',
  Incident: 'list_incidents',
  MonitoringManagementKpi: 'list_monitoring_management_kpi',
  MonitoringManagementPmc: 'list_monitoring_management_pmc',
  PrivacyByDesign: 'list_privacy_by_design',
  PrivacyPolicy: 'list_privacy_policy',
  Questionnaire: 'list_question_controls',
  QuestionControl: 'list_question_controls',
  Ticket: 'list_titular_tickets',
}

const ORIGIN_OPTIONS = [
  { id: 'all', name: 'Todas' },
  { id: 'manual', name: 'Manual' },
  { id: 'automatic', name: 'Automática' },
]

const MODULE_OPTIONS = [
  { id: 'all', name: 'Todos' },
  ...Object.entries(SOURCE_ORIGIN_LABELS).map(([id, name]) => ({ id, name })),
]

const FINALIZED_PERIOD_UNIT_ITEMS = [
  { id: 'days', name: 'Dias' },
  { id: 'months', name: 'Meses' },
]

const FINALIZED_PERIOD_UNLIMITED_UNIT = 'unlimited'
const FINALIZED_PERIOD_DEFAULT_UNIT = 'months'
const FINALIZED_PERIOD_DEFAULT_AMOUNT = 6

const NOTIFICATION_FREQUENCIES = ['instant', 'daily', 'weekly']

const NOTIFICATION_DISABLED_HINT =
  'Não disponível como instantânea, esta notificação funciona apenas em formato de resumo.'

const NOTIFICATION_ACCENT_COLOR = palette.primary.dark

const NOTIFICATION_COMPANY_TAB_HINT =
  'Configure as notificações individuais de todas as atividades da organização. Assim você é avisado sobre qualquer atividade criada, atualizada ou concluída, mesmo quando não é o responsável por ela.'

// Abas da tela de Configurações de Notificação (scope do bucket notification_preferences)
const NOTIFICATION_SCOPE_TABS = {
  MINE: 'mine',
  COMPANY: 'company',
  AUTOMATIC: 'automatic',
}

const NOTIFICATION_COLUMNS = [
  {
    id: 'disabled',
    label: 'Desativado',
    color: { main: palette.custom.disabled },
  },
  {
    id: 'instant',
    label: 'Instantâneo',
    color: { main: palette.permission.user.main },
  },
  {
    id: 'daily',
    label: 'Resumo Diário',
    color: { main: palette.permission.department.main },
  },
  {
    id: 'weekly',
    label: 'Resumo Semanal',
    color: { main: palette.permission.organization.main },
  },
]

// mesma ordem dos menus/submenus em helpers/auth/mountMenuItems.js
const AUTOMATIC_ACTIVITIES_MODULE_ORDER = [
  'Questionnaire',
  'QuestionControl',
  'PrivacyByDesign',
  'DataProcess',
  'DataProcessTreatment',
  'Incident',
  'Ticket',
  'SolicitationTicket',
  SOURCEABLE_TYPE_COMPLAINT,
  'ConsentForm',
  'GovernanceProject',
  'MonitoringManagementKpi',
  'MonitoringManagementPmc',
  'ChangesManagement',
  'PrivacyPolicy',
  'CookieBanner',
]

const AUTOMATIC_ACTIVITIES_NOTIFICATION_EVENTS =
  AUTOMATIC_ACTIVITIES_MODULE_ORDER.map((id) => ({
    id,
    title: SOURCE_ORIGIN_LABELS[id],
    subtitle: `Recebe email das atividades automáticas de ${SOURCE_ORIGIN_LABELS[id]}`,
  }))

// coluna única da aba "Atividades Automáticas" — não tem frequência própria,
// só liga/desliga o módulo (a frequência vem de "Minhas atividades"/"Toda
// Organização"). Backend guarda a chave em snake_case (KanbanConfiguration::
// AUTOMATIC_MODULES) — o axios re-casa toda chave de objeto recursivamente
// (helpers/changeCase/keys.js), então a chave de preferência não é o `id`
// PascalCase usado pra label/ícone/permissão, e sim a versão camelCase dele.
const AUTOMATIC_ACTIVITIES_COLUMN_WIDTH = 190

const AUTOMATIC_ACTIVITIES_COLUMNS = [
  {
    id: 'mine',
    label: 'Minhas atividades',
    color: { main: palette.permission.user.main },
    width: AUTOMATIC_ACTIVITIES_COLUMN_WIDTH,
  },
  {
    id: 'company',
    label: 'Da Organização',
    color: { main: palette.permission.organization.main },
    width: AUTOMATIC_ACTIVITIES_COLUMN_WIDTH,
  },
]

const automaticPreferenceKeyFor = (moduleId) =>
  moduleId.charAt(0).toLowerCase() + moduleId.slice(1)

const NOTIFICATION_SETTINGS_DRIVER_STEP_0 =
  'notification-settings-driver-step-0'
const NOTIFICATION_SETTINGS_DRIVER_STEP_MINE =
  'notification-settings-driver-step-mine'
const NOTIFICATION_SETTINGS_DRIVER_STEP_COMPANY =
  'notification-settings-driver-step-company'
const NOTIFICATION_SETTINGS_DRIVER_STEP_AUTOMATIC =
  'notification-settings-driver-step-automatic'

const NOTIFICATION_SETTINGS_DRIVER_STEPS_OBJECT = [
  {
    element: '#' + NOTIFICATION_SETTINGS_DRIVER_STEP_0,
    popover: {
      description:
        'Esta é a tela de configurações de notificação. Aqui você define quais e-mails deseja receber, organizados em três grupos: suas atividades, atividades de toda a organização e atividades automáticas do sistema.',
    },
  },
  {
    element: '#' + NOTIFICATION_SETTINGS_DRIVER_STEP_MINE,
    popover: {
      description:
        'Aqui você encontra as notificações relacionadas às suas próprias atividades. Você pode escolher, para cada tipo de notificação, se quer recebê-la de forma instantânea, em um resumo diário ou em um resumo semanal, ou simplesmente desativá-la.',
    },
  },
  {
    element: '#' + NOTIFICATION_SETTINGS_DRIVER_STEP_COMPANY,
    popover: {
      description:
        'Nesta aba você configura os resumos das atividades realizadas por todo o seu departamento ou pela organização como um todo. Por exemplo, você pode ativar um resumo semanal que reúne tudo o que foi feito no período, como "3 usuários concluíram 12 atividades".',
    },
  },
  {
    element: '#' + NOTIFICATION_SETTINGS_DRIVER_STEP_AUTOMATIC,
    popover: {
      description:
        'Aqui ficam as notificações geradas automaticamente pelo sistema. Você pode selecionar, módulo a módulo, se deseja ou não receber e-mails sobre essas atividades automáticas.',
    },
  },
]

const NOTIFICATION_EVENTS = [
  {
    id: 'activityCompleted',
    title: 'Atividade concluída',
    subtitle: 'Recebe email das atividades concluídas',
    iconName: 'CheckSquare',
    frequencies: ['instant', 'daily', 'weekly'],
  },
  {
    id: 'activityAssigned',
    title: 'Atividade vinculada a responsável',
    subtitle: 'Recebe email das atividades vinculada a responsável',
    iconName: 'User',
    frequencies: ['instant', 'daily', 'weekly'],
  },
  {
    id: 'statusChanged',
    title: 'Atividade com mudança de status',
    subtitle: 'Recebe email de atividades com mudanças de status',
    iconName: 'Inbox',
    frequencies: ['instant', 'daily', 'weekly'],
  },
  {
    id: 'overdue',
    title: 'Atividades atrasadas',
    subtitle: 'Recebe email das atividades atrasadas',
    iconName: 'AlertTriangle',
    frequencies: ['daily', 'weekly'],
  },
  {
    id: 'summary',
    title: 'Resumo geral das atividades',
    subtitle: 'Recebe resumo das atividades',
    iconName: 'Archive',
    frequencies: ['daily', 'weekly'],
  },
]

const activities = {
  ACTIVITIES_CONCLUDED_VALUE,
  ACTIVITIES_DELAYED_VALUE,
  ACTIVITIES_IN_PROGRESS_VALUE,
  ACTIVITIES_PENDING_VALUE,
  ACTIVITIES_TAB,
  ALL_ACTIVITIES_VALUE,
  AUTOMATIC_ACTIVITIES_COLUMNS,
  AUTOMATIC_ACTIVITIES_NOTIFICATION_EVENTS,
  automaticPreferenceKeyFor,
  CUSTOM_ORDER_FIELDS,
  DRAG_TYPE_CARD,
  DRAG_TYPE_COLUMN,
  FINALIZED_PERIOD_DEFAULT_AMOUNT,
  FINALIZED_PERIOD_DEFAULT_UNIT,
  FINALIZED_PERIOD_UNIT_ITEMS,
  FINALIZED_PERIOD_UNLIMITED_UNIT,
  FINALIZED_STATUS,
  HIGH,
  KANBAN_COLUMN_ROLE_CUSTOM,
  KANBAN_COLUMN_ROLE_FINALIZED,
  KANBAN_COLUMN_ROLE_IN_APPROVAL,
  KANBAN_COLUMN_ROLE_IN_PROGRESS,
  KANBAN_COLUMN_ROLE_PENDING,
  KANBAN_COLUMN_PALETTE_COLORS,
  KANBAN_COLUMN_STATES_ORDER,
  KANBAN_DEFAULT_ORDER,
  KANBAN_ORDER_FIELD,
  LINK_STATUS_ACTIVE_VALUE,
  LINK_STATUS_SOURCE_REMOVED_VALUE,
  LINK_STATUS_UNLINKED_VALUE,
  LOW,
  MEDIUM,
  TASK_NAME_MAX_LENGTH,
  MODULE_OPTIONS,
  NOTIFICATION_ACCENT_COLOR,
  NOTIFICATION_COMPANY_TAB_HINT,
  NOTIFICATION_SCOPE_TABS,
  NOTIFICATION_COLUMNS,
  NOTIFICATION_DISABLED_HINT,
  NOTIFICATION_EVENTS,
  NOTIFICATION_FREQUENCIES,
  NOTIFICATION_SETTINGS_DRIVER_STEP_0,
  NOTIFICATION_SETTINGS_DRIVER_STEP_AUTOMATIC,
  NOTIFICATION_SETTINGS_DRIVER_STEP_COMPANY,
  NOTIFICATION_SETTINGS_DRIVER_STEP_MINE,
  NOTIFICATION_SETTINGS_DRIVER_STEPS_OBJECT,
  ONGOING_STATUS,
  ORIGIN_OPTIONS,
  OVERDUE_STATUS,
  PENDING_STATUS,
  PRIORITY_ITEMS,
  PRIORITY_LABELS,
  SEVERE,
  SOURCE_ORIGIN_LABELS,
  SOURCE_ORIGIN_PERMISSION_TAGS,
  SOURCEABLE_TYPE_COMPLAINT,
  TASK_ATTACHMENT_FILE_TYPES,
  VIEW_MODE_KANBAN,
  VIEW_MODE_LIST,
}

export default activities
